<!-- page title -->

<h1>Assets Management</h1>

<ng-container *ngIf="viewModel$ | async as viewModel">
    <form class="actions-bar" [formGroup]="filtersForm" novalidate>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start start"
            class="toolbar">
            <button type="button" mat-raised-button color="accent" matTooltip="Add new record"
                [routerLink]="['upload-assets']">
                <mat-icon class="">add</mat-icon> Upload Assets
            </button>
            <button type="button" mat-raised-button color="accent" matTooltip="Add Asset Record"
                [routerLink]="['add-asset']">
                <mat-icon class="">add</mat-icon> Add Asset Record
            </button>

            <button type="button"
                *ngIf="(viewModel.viewMode === 'TABLE' && assetsTable?.getSelectedSectionRecords()?.length > 0) || (viewModel.viewMode === 'CARDS' && assetsCards?.getSelectedSectionRecords()?.length > 0)"
                mat-raised-button [matMenuTriggerFor]="menu" matTooltip="Actions">
                <mat-icon>more_vert</mat-icon>Actions
            </button>
            <mat-menu #menu="matMenu">
                <button type="button" mat-menu-item
                    [matMenuTriggerFor]="Download"><mat-icon>arrow_circle_down</mat-icon>Download</button>
                <!-- <button type="button" mat-menu-item><mat-icon>file_copy</mat-icon>Copy</button>   -->
                <button type="button" mat-menu-item
                    [disabled]="!((viewModel.viewMode === 'TABLE' && assetsTable?.getSelectedSectionRecords()?.length > 0) || (viewModel.viewMode === 'CARDS' && assetsCards?.getSelectedSectionRecords()?.length > 0))"
                    (click)="bulkUpdateAsDoNotUse()"><mat-icon>block</mat-icon>Mark Do Not Use</button>
                <button type="button" mat-menu-item
                    (click)="deleteSelectedRecords()"><mat-icon>delete</mat-icon>Delete</button>
                <button type="button" mat-menu-item
                    *ngIf="(viewModel.viewMode === 'TABLE' && assetsTable?.getSelectedSectionRecords()?.length > 0) || (viewModel.viewMode === 'CARDS' && assetsCards?.getSelectedSectionRecords()?.length > 0)">
                    {{ viewModel.viewMode === 'TABLE' ? assetsTable?.getSelectedSectionRecords()?.length :
                    assetsCards?.getSelectedSectionRecords()?.length}} Selected
                </button>
            </mat-menu>
            <mat-menu #Download="matMenu">
                <button mat-menu-item (click)="downloadJSON()">JSON</button>
                <button mat-menu-item (click)="downloadCSV()">CSV</button>
            </mat-menu>

            <mat-form-field appearance="outline" class="mat-form-field-no-padding search-field">
                <mat-icon matPrefix>search</mat-icon>
                <input matInput formControlName="search" type="text" placeholder="Search" #searchInput />
                <button type="button" matSuffix mat-icon-button aria-label="Clear" *ngIf="searchInput.value"
                    (click)="clearSearch()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <span class="menu-spacer"></span>

            <mat-button-toggle-group #group="matButtonToggleGroup" value="cards">
                <mat-button-toggle *ngIf="viewModel.viewMode === 'TABLE'" value="cards" matTooltip="Card view"
                    aria-label="Card view" (click)="toggleView('CARDS')">
                    <mat-icon>grid_view</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle *ngIf="viewModel.viewMode === 'CARDS'" value="table" matTooltip="Table view"
                    aria-label="Table view" (click)="toggleView('TABLE')">
                    <mat-icon>table_view</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle #filterToggleButton type="button" mat-stroked-button matTooltip="Show/hide filters"
                    (click)="filterSidenav.toggle()">
                    <mat-icon>filter_alt</mat-icon>
                </mat-button-toggle>
            </mat-button-toggle-group>

        </div>

        <mat-sidenav-container>
            <mat-sidenav #filterSidenav mode="over" position="end">
                <mat-toolbar>
                    Filter
                    <span class="menu-spacer"></span>
                    <button type="button" mat-icon-button aria-label="Close filter menu" matTooltip="Close filter menu"
                        (click)="filterSidenav.toggle()">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-toolbar>
                <div style="margin: 16px">
                    <div fxLayout="column">

                        <mat-form-field appearance="outline">
                            <mat-label>Upload Start Date</mat-label>
                            <input matInput [matDatepicker]="startDatePicker" formControlName="startDate">
                            <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
                            <mat-error *ngIf="filtersForm.controls.startDate.hasError('required')">
                                Upload start date is required
                            </mat-error>
                            <mat-error *ngIf="filtersForm.controls.startDate.hasError('matStartDateInvalid')">
                                Invalid upload start date
                            </mat-error>
                            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Upload End Date</mat-label>
                            <input matInput [matDatepicker]="endDatePicker" formControlName="endDate">
                            <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
                            <mat-error *ngIf="filtersForm.controls.endDate.hasError('required')">
                                Upload end date is required
                            </mat-error>
                            <mat-error *ngIf="filtersForm.controls.endDate.hasError('matEndDateInvalid')">
                                Invalid upload end date
                            </mat-error>
                            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #endDatePicker></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Asset Group</mat-label>
                            <mat-select formControlName="assetGroups" multiple [compareWith]="compareWithIdFn">
                                <mat-option *ngFor="let group of viewModel.assetGroups" [value]="group">
                                    {{group.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>File Type</mat-label>
                            <mat-select formControlName="fileTypes" multiple [compareWith]="compareWithIdFn">
                                <mat-option *ngFor="let type of viewModel.fileTypes" [value]="type">
                                    {{type.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                    </div>
                    <div fxLayout="row" fxLayoutAlign="end start" fxLayoutGap="16px">
                        <button type="reset" mat-stroked-button matTooltip="Reset filters" (click)="onFiltersReset()">
                            Reset
                        </button>
                        <button type="button" mat-raised-button matTooltip="Apply filters" color="accent"
                            (click)="onFiltersApply()">
                            Apply
                        </button>
                    </div>
                </div>

            </mat-sidenav>

            <!--filter chips -->
            <div class="filter-chips" *ngIf="filters.length > 0" fxLayout="row">
                <mat-chip-set aria-label="Selected filters">
                    <mat-chip *ngFor="let filter of filters" (removed)="removeFilter(filter)" removable="true">
                        {{filter.displayText}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                </mat-chip-set>

                <button type="button" class="filter_close_btn" mat-flat-button matTooltip="Remove all filters"
                    (click)="onFiltersReset()"> Clear all </button>
            </div>

            <app-asset-list-cards #assetsCards *ngIf="viewModel.viewMode === 'CARDS'"></app-asset-list-cards>
            <!--expansion view-->
            <app-asset-list-table #assetsTable *ngIf="viewModel.viewMode === 'TABLE'"></app-asset-list-table>

        </mat-sidenav-container>


    </form>
</ng-container>

<ng-template #loading>
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</ng-template>